import { testMobileNumber, validateEmail } from '@getaccept/lib-shared-new/src/helpers';
import { t } from '@getaccept/lib-shared-new/src/helpers/translation.helper';

export class InviteModalHelper {
  static validateMobile(mobile: string, hasSmsToSign: boolean): string {
    if (!mobile) {
      return hasSmsToSign ? t('phone-number-is-required') : '';
    }
    return !testMobileNumber(mobile) ? t('enter-a-valid-phone-number') : '';
  }

  static validateEmail(email: string): string {
    if (!email) {
      return t('email-is-required');
    }
    return !validateEmail(email.toLowerCase()) ? t('enter-a-valid-email') : '';
  }

  static validateName(nameType: 'first' | 'last', name: string): string {
    if (!name) {
      return t(`${nameType}-name-is-required`);
    }
    return '';
  }
}
